import { Button } from "reactstrap";
import "../../styles/Login.css";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { postSSOLogin } from "../../services/LoginAPI.tsx";
import { addListener, callLogin, getLoginParam } from "./LoginPageHelper.tsx";
import { useMsal } from "@azure/msal-react";
import CenterSpinner from "../../components/UI/CenterSpinner.tsx";

const Login = () => {
  const dispatch: any = useDispatch();
  const initialized = useRef(false);
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = useState(false);

  const onSuccessfulLogin = (payload: any) => {
    dispatch(postSSOLogin(getLoginParam(payload), setIsLoading));
  };
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      addListener(instance, onSuccessfulLogin);
    }
  }, []);

  return (
    <div className="mainDiv">
      <div className="leftDiv">
        <img
          alt="left"
          className="leftImage"
          src={require("../../assets/images/frame.svg").default}
        ></img>
        <img
          alt="right"
          className="rightImage"
          src={require("../../assets/images/laptopicon.svg").default}
        ></img>
      </div>
      <div className="rightDiv">
        <img
          alt="logo"
          className="mainLogo"
          src={require("../../assets/images/kshema_logo.svg").default}
        ></img>
        <div className="d-flex justify-content-center">
          <Button
            className="loginBtn"
            onClick={(e) => {
              callLogin(e, instance);
              setIsLoading(true);
            }}
          >
            Login
          </Button>
        </div>
      </div>
      <CenterSpinner showLoader={isLoading} />
    </div>
  );
};

export default Login;
